import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure
} from '@chakra-ui/react';

const BetweenQuestionScoreModal = ({ isOpen, onClose, title, content }) => {
  return (
    <Modal size='4xl' isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textStyle='h5'>{title}</ModalHeader>
        <ModalBody>
          {content}
        </ModalBody>
        <ModalFooter justifyContent={"center"}>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            ปิด
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default BetweenQuestionScoreModal;
